module.exports = __webpack_public_path__ + "static/media/trusted_companies.645d0c14.png";